import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, RadioGroup, FormControlLabel, Radio, Typography, Box,
} from '@mui/material';
import { useState } from 'react';
import type { AlphaAngle } from '../../../types/photo';

interface Props {
  open: boolean;
  fileCount: number;
  onConfirm: (alpha: AlphaAngle) => void;
  onCancel: () => void;
}

const OPTIONS: { value: AlphaAngle; label: string; desc: string }[] = [
  { value: 'low', label: 'Low (0\u00B0 \u2013 30\u00B0)', desc: 'Wider crop \u2014 low-angle fracture planes' },
  { value: 'average', label: 'Average (30\u00B0 \u2013 75\u00B0)', desc: 'Standard crop \u2014 most common' },
  { value: 'high', label: 'High (75\u00B0 \u2013 90\u00B0)', desc: 'Narrower crop \u2014 steep fracture planes' },
];

export const AlphaAngleDialog = ({ open, fileCount, onConfirm, onCancel }: Props) => {
  const [alpha, setAlpha] = useState<AlphaAngle>('average');

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Alpha Angle Classification</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Select the approximate alpha angle range of the sample&apos;s fracture plane.
          This controls the crop frame size.
        </Typography>
        <RadioGroup value={alpha} onChange={(e) => setAlpha(e.target.value as AlphaAngle)}>
          {OPTIONS.map((opt) => (
            <FormControlLabel
              key={opt.value}
              value={opt.value}
              control={<Radio />}
              label={
                <Box>
                  <Typography variant="body1">{opt.label}</Typography>
                  <Typography variant="caption" color="text.secondary">{opt.desc}</Typography>
                </Box>
              }
              sx={{ mb: 1 }}
            />
          ))}
        </RadioGroup>
        <Typography variant="body2" sx={{ mt: 2, fontWeight: 500 }}>
          {fileCount} photo{fileCount !== 1 ? 's' : ''} will be uploaded and auto-processed.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" onClick={() => onConfirm(alpha)}>
          Upload &amp; Process
        </Button>
      </DialogActions>
    </Dialog>
  );
};
